/* Tavora Beauty — thème Shopify. Panier branché sur l'API Ajax Shopify. */
(function () {
  "use strict";
  var CFG = window.TAVORA || {};
  var ROUTES = CFG.routes || { cartAdd: "/cart/add.js", cartChange: "/cart/change.js", cart: "/cart.js", checkout: "/checkout" };
  var FREE = CFG.freeShipping || 6000;   // en centimes
  var FLAT = CFG.flatRate || 490;         // en centimes (4,90 €)
  var eur = function (cents) { return (cents / 100).toFixed(2).replace(".", ",") + " €"; };

  /* ---------- Barre d'annonce rotative ---------- */
  (function () {
    var items = document.querySelectorAll("#topbar .tb-item");
    if (items.length < 2) return;
    var cur = 0;
    setInterval(function () {
      var prev = items[cur];
      cur = (cur + 1) % items.length;
      var next = items[cur];
      prev.classList.remove("active");
      prev.classList.add("exit");
      next.classList.add("active");
      setTimeout(function () { prev.classList.remove("exit"); }, 650);
    }, 4000);
  })();

  /* ---------- Menu mobile ---------- */
  (function () {
    var burger = document.querySelector(".burger");
    var headerEl = document.querySelector("header");
    if (!burger || !headerEl) return;
    burger.addEventListener("click", function () { headerEl.classList.toggle("nav-open"); });
    document.querySelectorAll(".nav-links a").forEach(function (a) {
      a.addEventListener("click", function () { headerEl.classList.remove("nav-open"); });
    });
  })();

  /* ---------- Galerie produit (DOM, images rendues côté serveur) ---------- */
  (function () {
    var gMain = document.getElementById("mainImg");
    var gThumbs = document.getElementById("thumbs");
    if (!gMain || !gThumbs) return;
    var thumbs = [].slice.call(gThumbs.children);
    var gIdx = 0;
    window.gShow = function (i) {
      var n = thumbs.length;
      gIdx = ((i % n) + n) % n;
      var full = thumbs[gIdx].getAttribute("data-full");
      if (full) gMain.src = full;
      thumbs.forEach(function (c, j) { c.classList.toggle("active", j === gIdx); });
      document.querySelectorAll(".variant").forEach(function (v) {
        v.classList.toggle("active", +v.dataset.i === gIdx);
      });
      var active = thumbs[gIdx];
      if (active) active.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "smooth" });
    };
    window.gMove = function (d) { window.gShow(gIdx + d); };
    thumbs.forEach(function (t, i) { t.addEventListener("click", function () { window.gShow(i); }); });
    document.querySelectorAll("#galleryMain .gnav").forEach(function (btn) {
      btn.addEventListener("click", function () { window.gMove(parseInt(btn.dataset.gmove, 10)); });
    });
    // Swipe sur l'image principale
    var m = document.getElementById("galleryMain");
    if (m) {
      var x0 = null;
      m.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      m.addEventListener("touchend", function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) window.gMove(dx < 0 ? 1 : -1);
        x0 = null;
      });
    }
  })();

  /* ---------- Accordéons (Description / FAQ) ---------- */
  document.querySelectorAll(".acc-q").forEach(function (q) {
    var a = q.nextElementSibling;
    if (q.classList.contains("open") && a) a.style.maxHeight = a.scrollHeight + "px";
    q.addEventListener("click", function () {
      var open = q.classList.contains("open");
      var scope = q.closest("[data-acc]") || document;
      scope.querySelectorAll(".acc-q").forEach(function (o) {
        o.classList.remove("open");
        if (o.nextElementSibling) o.nextElementSibling.style.maxHeight = null;
      });
      if (!open) { q.classList.add("open"); if (a) a.style.maxHeight = a.scrollHeight + "px"; }
    });
  });

  /* ---------- Sélecteur de préoccupation ---------- */
  document.querySelectorAll("#concernTabs .concern").forEach(function (c) {
    c.addEventListener("click", function () {
      document.querySelectorAll("#concernTabs .concern").forEach(function (x) { x.classList.remove("active"); });
      c.classList.add("active");
      var t = document.getElementById("cpT");
      var d = document.getElementById("cpD");
      if (t) t.textContent = c.dataset.t;
      if (d) d.textContent = c.dataset.d;
    });
  });

  /* ---------- Barre panier fixe ---------- */
  (function () {
    var bar = document.getElementById("stickyCart");
    var product = document.getElementById("produits");
    var footEnd = document.querySelector(".foot-bottom");
    if (!bar || !product || !("IntersectionObserver" in window)) return;
    var productVisible = false, footerVisible = false;
    function update() {
      var show = !productVisible && !footerVisible;
      bar.classList.toggle("show", show);
      bar.setAttribute("aria-hidden", show ? "false" : "true");
    }
    new IntersectionObserver(function (e) { productVisible = e[0].isIntersecting; update(); }, { threshold: 0 }).observe(product);
    if (footEnd) new IntersectionObserver(function (e) { footerVisible = e[0].isIntersecting; update(); }, { threshold: 0 }).observe(footEnd);
  })();

  /* ---------- Carrousel avis (coverflow) ---------- */
  (function () {
    var track = document.getElementById("revTrack");
    if (!track) return;
    var cards = [].slice.call(track.children);
    var n = cards.length;
    var rIdx = 0;
    window.rShow = function (i) {
      rIdx = ((i % n) + n) % n;
      var c = cards[rIdx];
      var shift = track.parentElement.clientWidth / 2 - (c.offsetLeft + c.offsetWidth / 2);
      track.style.transform = "translateX(" + shift + "px)";
      cards.forEach(function (card, j) { card.classList.toggle("is-active", j === rIdx); });
    };
    window.rMove = function (d) { window.rShow(rIdx + d); };
    cards.forEach(function (card, j) { card.addEventListener("click", function () { if (j !== rIdx) window.rShow(j); }); });
    document.querySelectorAll(".rev-nav").forEach(function (btn) {
      btn.addEventListener("click", function () { window.rMove(parseInt(btn.dataset.rmove, 10)); });
    });
    var x0 = null;
    var box = track.parentElement;
    box.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    box.addEventListener("touchend", function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) window.rMove(dx < 0 ? 1 : -1); x0 = null; });
    window.addEventListener("resize", function () { window.rShow(rIdx); });
    window.addEventListener("load", function () { window.rShow(rIdx); });
    window.rShow(0);
  })();

  /* ---------- Reveal au défilement ---------- */
  (function () {
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion:reduce)").matches;
    var targets = [].slice.call(document.querySelectorAll("section:not(.hero), footer"));
    if (reduce || !("IntersectionObserver" in window)) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
    }, { threshold: 0, rootMargin: "0px 0px -8% 0px" });
    targets.forEach(function (el) {
      if (el.getBoundingClientRect().top > vh * 0.9) { el.classList.add("reveal"); io.observe(el); }
    });
  })();

  /* ---------- Sélection de variante (prix dynamique) ---------- */
  var VARIANTS = [];
  (function () {
    var el = document.getElementById("ProductVariantsJson");
    if (el) { try { VARIANTS = JSON.parse(el.textContent); } catch (e) { VARIANTS = []; } }
    function variantById(id) { for (var i = 0; i < VARIANTS.length; i++) { if (String(VARIANTS[i].id) === String(id)) return VARIANTS[i]; } return null; }
    function activeVariant() {
      var btn = document.querySelector(".variant.active[data-variant-id]") || document.querySelector(".variant[data-variant-id]");
      if (btn) return variantById(btn.dataset.variantId);
      return VARIANTS[0] || null;
    }
    function priceHtml(v) {
      if (!v) return "";
      var html = eur(v.price);
      if (v.compare_at_price && v.compare_at_price > v.price) {
        html += ' <s>' + eur(v.compare_at_price) + '</s> <span class="save">Économisez ' + eur(v.compare_at_price - v.price) + '</span>';
      }
      return html;
    }
    function refreshPrice() {
      var v = activeVariant();
      if (!v) return;
      var pPrice = document.getElementById("pPrice");
      if (pPrice) pPrice.innerHTML = priceHtml(v);
      var addBtn = document.querySelector(".add-cart");
      if (addBtn && !addBtn.disabled) addBtn.textContent = "Ajouter au panier — " + eur(v.price);
      var sc = document.getElementById("scPrice");
      if (sc) sc.innerHTML = priceHtml(v);
    }
    // clic variante → image + prix
    document.querySelectorAll(".variant[data-variant-id]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        document.querySelectorAll(".variant").forEach(function (b) { b.classList.remove("active"); });
        btn.classList.add("active");
        refreshPrice();
      });
    });
    refreshPrice();
    window.__tavoraActiveVariant = activeVariant;
  })();

  /* ---------- Panier (API Ajax Shopify) ---------- */
  (function () {
    var drawer = document.getElementById("cartDrawer");
    var overlay = document.getElementById("cartOverlay");
    var body = document.getElementById("cartBody");
    var foot = document.getElementById("cartFoot");
    var totalEl = document.getElementById("cartTotal");
    var subEl = document.getElementById("cartSub");
    var shipValEl = document.getElementById("cartShipVal");
    var gaugeEl = document.getElementById("cartGauge");
    var msgEl = document.getElementById("cartShipMsg");
    var closeBtn = document.getElementById("cartClose");
    var countEl = document.querySelector(".cart-count");
    var cartBtn = document.querySelector(".cart-btn");
    var checkoutBtn = document.querySelector(".cart-checkout");
    if (!drawer || !countEl) return;

    function openCart() { overlay.classList.add("open"); drawer.classList.add("open"); drawer.setAttribute("aria-hidden", "false"); }
    function closeCart() { overlay.classList.remove("open"); drawer.classList.remove("open"); drawer.setAttribute("aria-hidden", "true"); }
    function bump() { countEl.classList.remove("pop"); void countEl.offsetWidth; countEl.classList.add("pop"); }

    function render(cart) {
      var count = cart.item_count || 0;
      countEl.textContent = count;
      countEl.style.display = count > 0 ? "flex" : "none";
      if (!cart.items || !cart.items.length) {
        body.innerHTML = '<div class="cart-empty"><p>Votre panier est vide.</p><a href="#produits" class="btn btn-pink" data-close-cart>Découvrir l’Auralift™</a></div>';
        foot.style.display = "none";
        return;
      }
      foot.style.display = "block";
      body.innerHTML = cart.items.map(function (it) {
        var img = it.image ? it.image : (it.featured_image && it.featured_image.url ? it.featured_image.url : "");
        return '<div class="cart-line">' +
          '<img src="' + img + '" alt="' + (it.product_title || "") + '">' +
          '<div class="cl-info">' +
            '<div class="cl-row"><span class="cl-name">' + (it.product_title || "") + '</span><button class="cl-remove" data-rm="' + it.key + '">Retirer</button></div>' +
            '<div class="cl-var">' + (it.variant_title && it.variant_title !== "Default Title" ? it.variant_title : "") + '</div>' +
            '<div class="cl-row">' +
              '<span class="cl-qty"><button data-dec="' + it.key + '" aria-label="Diminuer">−</button><span>' + it.quantity + '</span><button data-inc="' + it.key + '" aria-label="Augmenter">+</button></span>' +
              '<span class="cl-price" style="margin-left:auto">' + eur(it.final_line_price) + '</span>' +
            '</div>' +
          '</div>' +
        '</div>';
      }).join("");
      var st = cart.total_price;
      var ship = 0;
      subEl.textContent = eur(st);
      shipValEl.innerHTML = '<span class="free">Offerte</span>';
      totalEl.textContent = eur(st + ship);
      gaugeEl.style.width = "100%";
      msgEl.innerHTML = "🎉 Vous bénéficiez de la <b>livraison offerte</b> !";
    }

    function getCart() { return fetch(ROUTES.cart, { headers: { "Content-Type": "application/json" } }).then(function (r) { return r.json(); }); }
    function refresh(open) { return getCart().then(function (c) { render(c); if (open) { openCart(); bump(); } }); }

    function addVariant(id) {
      if (!id) { alert("Veuillez sélectionner un coloris."); return; }
      return fetch(ROUTES.cartAdd, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      }).then(function (r) { return r.json(); }).then(function () { return refresh(true); })
        .catch(function () { alert("Une erreur est survenue. Veuillez réessayer."); });
    }

    function changeLine(key, qty) {
      return fetch(ROUTES.cartChange, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function (c) { render(c); });
    }

    body.addEventListener("click", function (e) {
      var t = e.target.closest("button, a");
      if (!t) return;
      if (t.dataset.inc) { changeLine(t.dataset.inc, qtyOf(t.dataset.inc) + 1); }
      else if (t.dataset.dec) { changeLine(t.dataset.dec, Math.max(0, qtyOf(t.dataset.dec) - 1)); }
      else if (t.dataset.rm) { changeLine(t.dataset.rm, 0); }
      else if (t.hasAttribute("data-close-cart")) { closeCart(); }
    });
    var _lastCart = { items: [] };
    function qtyOf(key) { for (var i = 0; i < _lastCart.items.length; i++) { if (_lastCart.items[i].key === key) return _lastCart.items[i].quantity; } return 0; }
    // garder une copie pour qtyOf
    var _origRender = render;
    render = function (c) { _lastCart = c; _origRender(c); };

    overlay.addEventListener("click", closeCart);
    if (closeBtn) closeBtn.addEventListener("click", closeCart);
    if (cartBtn) cartBtn.addEventListener("click", function () { refresh(true); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeCart(); });
    if (checkoutBtn) checkoutBtn.addEventListener("click", function () { window.location.href = ROUTES.checkout; });

    var addBtn = document.querySelector(".add-cart");
    if (addBtn && !addBtn.disabled) {
      addBtn.addEventListener("click", function () {
        var v = window.__tavoraActiveVariant ? window.__tavoraActiveVariant() : null;
        var id = (v && v.id) ? v.id : addBtn.getAttribute("data-variant-id");
        addVariant(id);
      });
    }

    // état initial (badge + tiroir)
    refresh(false);
  })();
})();
